import React from "react";
import Reveal from "./Reveal";

export default function Founder() {
  return (
    <section
      id="founder"
      className="py-10 md:py-14 border-t hairline"
      data-testid="founder-section"
    >
      <div className="container-edge">
        <Reveal>
          <p className="section-number">13 — THE FOUNDER</p>
        </Reveal>
        <Reveal>
          <h2
            className="mt-6 font-display text-[26px] sm:text-[32px] tracking-tight"
            style={{ fontWeight: 500 }}
          >
            Built by builders.
          </h2>
        </Reveal>

        <div className="mt-8 grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12">
          {/* Photo */}
          <div className="lg:col-span-3">
            <Reveal>
              <div
                className="relative card-edge overflow-hidden max-w-[280px]"
                style={{ borderRadius: 4, aspectRatio: "4/5" }}
                data-testid="founder-photo"
              >
                <img
                  src="/assets/founder.jpg"
                  alt="Soumojit Das — Founder & Director, AI For Everyone"
                  className="w-full h-full object-cover"
                  style={{ objectPosition: "center 18%" }}
                  loading="lazy"
                />
                <span
                  aria-hidden="true"
                  className="absolute inset-0 pointer-events-none"
                  style={{
                    background:
                      "linear-gradient(180deg, rgba(10,14,31,0) 60%, rgba(10,14,31,0.2) 100%)",
                  }}
                />
              </div>
            </Reveal>
          </div>

          {/* Bio */}
          <div className="lg:col-span-9 flex flex-col justify-center">
            <Reveal delay={120}>
              <p className="mono-label-gold">SOUMOJIT DAS</p>
              <p
                className="mt-1 font-mono text-[12px]"
                style={{ color: "var(--ink-tertiary)", letterSpacing: "0.12em" }}
              >
                FOUNDER & DIRECTOR · AI FOR EVERYONE
              </p>
            </Reveal>

            <Reveal delay={180}>
              <div className="mt-5 space-y-3 max-w-[640px]">
                <p
                  className="font-display text-[18px] md:text-[20px] leading-snug"
                  style={{ fontWeight: 400, color: "var(--ink)" }}
                >
                  <span className="italic">18 years</span> across SAP, digital
                  transformation, AI mentorship, and AI adoption.
                  <span className="italic"> Certified PMO from IIM Indore.</span>
                </p>
                <p
                  className="text-[14px] leading-relaxed"
                  style={{ color: "var(--ink-secondary)" }}
                >
                  Founder of InTime IT Services Pvt. Ltd. — the parent company behind AI For
                  Everyone, Excentra, and Aurevia.
                </p>
              </div>
            </Reveal>

            <Reveal delay={240}>
              <a
                href="https://www.linkedin.com/in/soumojitdasintime/"
                target="_blank"
                rel="noopener noreferrer"
                className="mt-6 inline-flex items-center gap-2 text-[14px] link-underline text-ink"
                data-testid="founder-linkedin"
              >
                LinkedIn →
              </a>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
}
